import { Box, BoxProps } from "@chakra-ui/react";
import { FiTrash2 } from "react-icons/fi";

export const TrashIcon = (props: BoxProps) => {
  return <Box as={FiTrash2} height="20px" width="20px" {...props} />;
};
